import { NavLink, useSearchParams } from '@remix-run/react';

interface BreadCrumbsProps {
	pages?: {
		name: string;
		href: string;
		current: boolean;
	}[];
}

export function BreadCrumbs({ pages }: BreadCrumbsProps) {
	const [currentParams] = useSearchParams();
	return (
		<nav className="flex" aria-label="Breadcrumb">
			<ol role="list" className="flex items-center space-x-0.5">
				{pages?.map((page, index) => {
					const params = new URLSearchParams(page.href.split('?')[1]);
					const paramsMatch = !params || currentParams.toString() === params.toString();

					return (
						<li key={page.name}>
							<div className="flex items-center">
								{index !== 0 && (
									<svg
										className="h-3 w-3 flex-shrink-0 text-grey"
										fill="currentColor"
										viewBox="0 0 20 20"
										aria-hidden="true"
									>
										<path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
									</svg>
								)}
								<NavLink
									to={page.href}
									end
									aria-current={!!page.current ? 'page' : undefined}
									className={({ isActive }) => (isActive && paramsMatch && index !== 0 ? 'text-blue' : 'text-grey')}
								>
									<h5 className="text-xs hover:text-blue uppercase">{page.name}</h5>
								</NavLink>
							</div>
						</li>
					);
				})}
			</ol>
		</nav>
	);
}
